import Lightbox from "../../../elements/lightbox/lightbox";

/**
 * Represents a Form including e.g. fieldsets, inputs, textarea, selects, buttons
 * all elements templates and stylings are defined by FSK
 * this class only takes care of validation
 */
class FormOrdersControl {
  /**
   * @param {HTMLElement} element - form
   */
  constructor(element) {
    this.element = element;

    this.endpointUrl = this.element.dataset.limitedWebformEndpoint;

    if (this.endpointUrl) this._init();
  }

  /**
   * init
   *
   * @private
   */
  _init() {
    const formData = {
      limited_webform: this.element.dataset.limitedWebform,
      limited_webform_page: this.element.dataset.limitedWebformPage,
    };

    fetch(this.endpointUrl, {
      method: "POST",
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => this._handleSuccessResponse(data))
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  }

  /**
   * Handle the response: disable the form and show the lightbox
   *
   * @param {object} data
   */
  _handleSuccessResponse(data) {
    if (data.active) {
      this._disableForm();
      FormOrdersControl._showLightbox(data.title, data.message);
    }
  }

  /**
   * Disable all forms elements
   */
  _disableForm() {
    Array.from(this.element.elements).forEach((element) => {
      // eslint-disable-next-line no-param-reassign
      element.disabled = true;
    });
  }

  /**
   * Display the lightbox with the data provided in the response
   *
   * @param {string} title
   * @param {string} copy
   */
  static _showLightbox(title = "", copy = "") {
    const lightboxEl = document.querySelector(".js-genericLightbox");
    const lightbox = new Lightbox(lightboxEl);
    if (title) {
      lightboxEl.querySelector(".js-Lightbox-title").innerHTML = title;
    }
    if (copy) {
      lightboxEl.querySelector(".js-Lightbox-copy").innerHTML = copy;
    }
    lightbox.openLightbox();
  }
}

export default FormOrdersControl;
